export default __webpack_public_path__ + "static/avantages-velotaf-927d8b9b91492590d1ccb237fbd6ddaf.png";